/**
 * RAHUL IAS ACADEMY — ANALYTICS & COOKIE CONSENT
 * Solan, Himachal Pradesh, India
 * GA4, GTM, Meta Pixel & GDPR Cookie Consent Architecture
 */

// ANALYTICS PLACEHOLDERS
const ANALYTICS_CONFIG = {
  GA4_MEASUREMENT_ID: 'G-XXXXXXXXXX', // Replace with GA4 Measurement ID
  GTM_ID: 'GTM-XXXXXXX',             // Replace with Google Tag Manager ID
  META_PIXEL_ID: 'META_PIXEL_ID',      // Replace with Meta Pixel ID
};

document.addEventListener('DOMContentLoaded', () => {
  const cookieBanner = document.getElementById('cookieConsentBanner');
  const acceptBtn = document.getElementById('acceptCookiesBtn');
  const rejectBtn = document.getElementById('rejectCookiesBtn');

  // Check if consent decision exists in localStorage
  const consentStatus = localStorage.getItem('rahul_ias_cookie_consent');

  if (!consentStatus && cookieBanner) {
    // Show banner if choice not saved
    cookieBanner.classList.add('is-active');
  } else if (consentStatus === 'accepted') {
    loadAnalyticsScripts();
  }

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      localStorage.setItem('rahul_ias_cookie_consent', 'accepted');
      if (cookieBanner) cookieBanner.classList.remove('is-active');
      loadAnalyticsScripts();
      console.log('[Analytics] User accepted tracking cookies.');
    });
  }

  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => {
      localStorage.setItem('rahul_ias_cookie_consent', 'rejected');
      if (cookieBanner) cookieBanner.classList.remove('is-active');
      console.log('[Analytics] User rejected non-essential tracking cookies.');
    });
  }
});

function loadAnalyticsScripts() {
  // Load GA4 if ID is replaced
  if (ANALYTICS_CONFIG.GA4_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_CONFIG.GA4_MEASUREMENT_ID}`;
    document.head.appendChild(gaScript);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', ANALYTICS_CONFIG.GA4_MEASUREMENT_ID);
    console.log('[Analytics] GA4 Initialized.');
  }

  // Load Meta Pixel if ID is replaced
  if (ANALYTICS_CONFIG.META_PIXEL_ID !== 'META_PIXEL_ID') {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ANALYTICS_CONFIG.META_PIXEL_ID);
    fbq('track', 'PageView');
    console.log('[Analytics] Meta Pixel Initialized.');
  }
}
